import _ from 'lodash';
import { SHOW_ROOM, HIDE_ROOM, SEND_MESSAGE, GET_USERS, SET_ACTIVE_ROOM, SET_ONLINE_STATUS } from '../actions/ChatActions';

const INITIAL_STATE = {
  users: [],
  rooms: [],
  me: {},
  activeRoom: 0,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SHOW_ROOM: {
      for (const room of state.rooms) {
        if (room.id === action.room.id) {
          return state;
        }
      }

      return {
        ...state,
        activeRoom: action.room.id,
        rooms: [...state.rooms, action.room],
      };
    }

    case HIDE_ROOM: {
      const rooms = _.filter(state.rooms, (room) => {
        return room.id !== action.room;
      });

      return {
        ...state,
        rooms,
      };
    }

    case SEND_MESSAGE: {
      const { userId, lastMessage, createdAt } = action.payload.data;
      const users = state.users.map((user) => {
        if (userId === user.id) {
          return { ...user, lastMessage, createdAt };
        }

        return user;
      });

      return {
        ...state,
        users,
      };
    }

    case GET_USERS: {
      const users = Array.isArray(action.payload.data) ? action.payload.data : [];
      const me = users.find(u => u.me === true) || {};

      return {
        ...state,
        users,
        me,
      };
    }

    case SET_ACTIVE_ROOM: {
      const { activeRoom } = action;
      return {
        ...state,
        activeRoom,
      };
    }

    case SET_ONLINE_STATUS: {
      const { userId, status } = action;

      const users = state.users.map((user) => {
        if (userId === user.id) {
          return { ...user, status };
        }

        return user;
      });
      const me = users.find(u => u.me === true) || {};

      return {
        ...state,
        users,
        me,
      };
    }

    default:
      return state;
  }
}
